import { render, staticRenderFns } from "./SidebarComposeMessageGroup.vue?vue&type=template&id=da9284f0&"
import script from "./SidebarComposeMessageGroup.vue?vue&type=script&lang=js&"
export * from "./SidebarComposeMessageGroup.vue?vue&type=script&lang=js&"
import style0 from "./SidebarComposeMessageGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports